import { AUTH_PROFILE, PROFILE_LIMITS, type ProfileNameFormProps } from '../constants/auth'

export function ProfileNameForm({
  label,
  value,
  onChange,
  onSubmit,
  onCancel,
  saving,
  error,
}: ProfileNameFormProps) {
  return (
    <form className="profile-page__form" onSubmit={onSubmit}>
      <input
        aria-label={label}
        autoComplete="name"
        placeholder={AUTH_PROFILE.namePlaceholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={PROFILE_LIMITS.nameMax}
        required
        autoFocus
        disabled={saving}
      />
      {error ? (
        <p className="profile-page__error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="profile-page__actions">
        <button type="submit" className="profile-page__save" disabled={saving}>
          {saving ? AUTH_PROFILE.saving : AUTH_PROFILE.save}
        </button>
        <button
          type="button"
          className="profile-page__cancel"
          onClick={onCancel}
          disabled={saving}
        >
          {AUTH_PROFILE.cancel}
        </button>
      </div>
    </form>
  )
}
